// src/services/api.js
import axios from 'axios'

// Base da API: ex.: VUE_APP_API_BASE="http://localhost:3000"
const baseURL = 'https://bot-oficial-api.manyconvert.com/'

export const http = axios.create({
  baseURL,
  timeout: 15000,
})

// Interceptor de erro: propaga uma Error mais legível
http.interceptors.response.use(
  r => r,
  err => {
    const msg = err?.response?.data?.error
      || err?.response?.data?.message
      || err?.message
      || 'Erro na API'
    return Promise.reject(new Error(msg))
  },
)

/**
 * Endpoints de fluxo/bot
 * - createBot({ account_id?, store_id?, nome|name })
 * - createVersion(botId, definitionJson)
 * - publishVersion(botId, version)
 * - setActiveBotForStore(storeId, botId, { version_id?, version? })
 * - getActiveVersion(botId)
 * - getStoreActiveFlow(storeId)
 * - listBotsByAccount(accountId)   <-- NOVO
 */
export const FlowsAPI = {
  /**
   * Cria um bot.
   * Aceita:
   *  - account_id (novo, obrigatório no seu cenário)
   *  - store_id (opcional, se seu backend permitir)
   *  - name/nome
   */
  createBot({
    account_id, store_id, nome, name,
  }) {
    const body = {
      // novo: account_id suportado
      ...(account_id != null ? { account_id } : {}),
      // legado: se ainda existir vínculo com loja
      ...(store_id != null ? { store_id } : {}),
      name: name || nome || 'Bot',
    }
    return http.post('/api/bots', body)
  },

  createVersion(botId, definitionJson) {
    return http.post(`/api/bots/${botId}/versions`, definitionJson)
  },

  publishVersion(botId, version) {
    return http.post(`/api/bots/${botId}/versions/${version}/publish`)
  },

  setActiveBotForStore(storeId, botId, opts = {}) {
    const body = { bot_id: botId }
    if (opts.version_id) body.version_id = opts.version_id
    else if (opts.version) body.version = opts.version
    return http.put(`/api/stores/${storeId}/active-bot`, body)
  },

  getActiveVersion(botId) {
    return http.get(`/api/bots/${botId}/versions/active`)
  },

  getStoreActiveFlow(storeId) {
    return http.get(`/api/stores/${storeId}/active-bot`)
  },

  // LISTAR versões (é esperado o endpoint GET /api/bots/:botId/versions)
  listVersions(botId, params = {}) {
    return http.get(`/api/bots/${botId}/versions`, { params }) // params: { limit?, order? }
  },

  // BUSCAR versão específica
  getVersion(botId, version) {
    return http.get(`/api/bots/${botId}/versions/${version}`)
  },

  /**
   * NOVO: Lista todos os bots pertencentes a um account_id (usuário/conta).
   * Backend esperado: GET /api/accounts/:accountId/bots
   */
  listBotsByAccount(accountId, params = {}) {
    return http.get(`/api/accounts/${accountId}/bots`, { params })
  },
}

export const MetaAPI = {
  listTemplates(params = {}) {
    return http.get('/meta/meta/templates', { params })
  },
}

export default { http, FlowsAPI }
